import { useState } from "react";
import { Link } from "react-router-dom";
import AuthShell from "../components/auth/AuthShell";
import { Field, inputCls } from "../components/forms/Fields";
import { api, formatApiError } from "../lib/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [msg, setMsg] = useState("");
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    try {
      const { data } = await api.post("/auth/forgot-password", { email, origin: window.location.origin });
      setMsg(data.message);
    } catch (err) {
      setError(formatApiError(err));
    }
  };

  return (
    <AuthShell title="Reset your password" subtitle="We'll email you a secure reset link." footer={<Link to="/login" className="font-semibold text-mint-600">Back to login</Link>}>
      {msg ? <p className="rounded-xl bg-mint/10 p-4 text-sm text-mint-600" data-testid="forgot-success">{msg}</p> : (
        <form onSubmit={submit} className="space-y-5" data-testid="forgot-form">
          <Field label="Email" id="f-email"><input id="f-email" type="email" required className={inputCls} value={email} onChange={(e) => setEmail(e.target.value)} data-testid="forgot-email-input" /></Field>
          {error && <p className="text-sm text-red-600">{error}</p>}
          <button type="submit" data-testid="forgot-submit-btn" className="h-12 w-full rounded-xl bg-navy text-sm font-semibold text-white hover:bg-navy-700">Send reset link</button>
        </form>
      )}
    </AuthShell>
  );
}
